import { render } from "./Footer.vue?vue&type=template&id=4ee749ba&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=4ee749ba&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee749ba"]])

export default __exports__